var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$route.meta.noLayout)?_c('div',{staticClass:"layout_mian"},[_c('div',{staticClass:"layout_left"},[_c('leftMenu')],1),_vm._v(" "),_c('div',{staticClass:"layout_right"},[_c('navBar'),_vm._v(" "),_c('tags-view'),_vm._v(" "),_c('appMain')],1)]):_c('div',[_c('appMain')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f7d8ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/index.vue
// module id = null
// module chunks = 